import { IHttpClient, FlowAPI } from '@wix/yoshi-flow-editor';
import {
  registerCommentsWidget as apiRegisterCommentsWidget,
  queryCommentsWidget as apiQueryCommentsWidget,
} from '@wix/ambassador-comments-categories-v1-comments-widget/http';
import { RegisterCommentsWidgetRequest } from '@wix/ambassador-comments-categories-v1-comments-widget/types';

export const createWidgetRegistryService = ({
  httpClient,
  errorHandler,
}: {
  httpClient: IHttpClient;
  errorHandler: FlowAPI['errorHandler'];
}) => {
  const service = {
    registerWidget: registerWidget(httpClient, errorHandler),
    queryWidgets: queryWidgets(httpClient, errorHandler),
  };

  return service;
};
// TODO
const registerWidget =
  (httpClient: IHttpClient, errorHandler: FlowAPI['errorHandler']) =>
  async (request: RegisterCommentsWidgetRequest) => {
    const { withErrorHandler, getResolvedError } = errorHandler;

    try {
      const response = await withErrorHandler(
        () => httpClient.request(apiRegisterCommentsWidget(request)),
        {
          errorCodesMap: {},
        },
      );
      return response;
    } catch (error) {
      getResolvedError(error);
      throw error;
    }
  };

const queryWidgets =
  (httpClient: IHttpClient, errorHandler: FlowAPI['errorHandler']) => async () => {
    const { withErrorHandler, getResolvedError } = errorHandler;

    try {
      const { data } = await withErrorHandler(
        () => httpClient.request(apiQueryCommentsWidget({ query: {} })),
        {
          errorCodesMap: {},
        },
      );
      return data.commentsWidgets ?? [];
    } catch (error) {
      getResolvedError(error);
      throw error;
    }
  };
